export class LoadIsFormValid {
    public static type = "[Form templates] Load form validation";

    constructor(public payload: boolean) {}
}
